<div class="d-flex">
  <div class="w-100">
    <div class="position-relative">
      <div class="parent-tag-container" #parentContainer></div>
      <div *ngIf="this.showPlaceHolder"
        class="text-truncate parent-tag-container-copy position-absolute {{ this.showPlaceHolder ? '' : 'd-none' }}">
        {{ title }}</div>
    </div>
  </div>
  <a class="lookup-icon bg-light" (click)="searchModifier()"><i class="bi bi-search fw-bold"></i></a>

</div>
